import React from "react";

const Redirect = () => {
  window.location.href = "https://hyperauth.app";
  return <></>;
};

export default Redirect;
